<template>
    <h3 class="ui-popover-headline">
        <slot></slot>
    </h3>
</template>
